import React from 'react'
import ReactDOM from 'react-dom'
import CaseStudy from '../../casestudy/components/CaseStudy'

const htmlElement = document.getElementById("casestudyapp");

ReactDOM.render(<CaseStudy apiUrl={htmlElement.dataset.apiurl} />,
    htmlElement)